// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagePin__container-a9ec56 {
  flex-shrink: 0;
  box-sizing: border-box;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 16px;
  padding-inline-end: 24px;
  display: flex;
  border-bottom: 1px solid var(--base-20);
  align-items: center;
  justify-content: space-between;
  background-color: var(--base-0);
  position: relative;
  height: 56px;
}

.MessagePin__remove-a34ac1 {
  fill: var(--base-60);
}

.MessagePin__pin-menu-icon-abfed9 {
  fill: var(--base-80);
  cursor: pointer;
}

.MessagePin__miniature-title-da031a {
  color: var(--brand-primary-40);
}

.MessagePin__miniature-text-e07c7e {
  color: var(--base-80);
}

.MessagePin__miniature-icon-b5d130 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/MessagePin/MessagePin.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,aAAA;EACA,uCAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  flex-shrink: 0;\n  box-sizing: border-box;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 16px;\n  padding-inline-end: 24px;\n  display: flex;\n  border-bottom: 1px solid var(--base-20);\n  align-items: center;\n  justify-content: space-between;\n  background-color: var(--base-0);\n  position: relative;\n  height: 56px;\n}\n\n.remove {\n  fill: var(--base-60);\n}\n\n.pin-menu-icon {\n  fill: var(--base-80);\n  cursor: pointer;\n}\n\n.miniature-title {\n  color: var(--brand-primary-40);\n}\n\n.miniature-text {\n  color: var(--base-80);\n}\n\n.miniature-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessagePin__container-a9ec56`,
	"remove": `MessagePin__remove-a34ac1`,
	"pin-menu-icon": `MessagePin__pin-menu-icon-abfed9`,
	"pinMenuIcon": `MessagePin__pin-menu-icon-abfed9`,
	"miniature-title": `MessagePin__miniature-title-da031a`,
	"miniatureTitle": `MessagePin__miniature-title-da031a`,
	"miniature-text": `MessagePin__miniature-text-e07c7e`,
	"miniatureText": `MessagePin__miniature-text-e07c7e`,
	"miniature-icon": `MessagePin__miniature-icon-b5d130`,
	"miniatureIcon": `MessagePin__miniature-icon-b5d130`
};
module.exports = ___CSS_LOADER_EXPORT___;
